import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'amountTypePipe'
})
export class TypeForAmountPipe implements PipeTransform {
    transform(value: any): string {
        return value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
}